export function BalanceChartSkeleton() {
    return (
        <div
            className='animate-pulse w-full flex flex-row justify-center items-center text-2xl rounded-md balance-chart-skeleton'
            style={{
                width: '95%',
                height: '400px',
                background: '#00000020',
                marginRight: 10,
                marginLeft: 32,
            }}>
            <div
                className='flex flex-col justify-center items-center'
                style={{ fontSize: 48 }}>
                {'🌽 '}
            </div>
        </div>
    )
}
